import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './StoreSection.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://saskararecord.com/api';

function formatPrice(price) {
  return new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    maximumFractionDigits: 0,
  }).format(price);
}

export default function StoreSection({ eyebrow = 'Merchandise', title = 'Saskara Store' }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/products/public?limit=8`)
      .then((res) => {
        if (mounted) setProducts(res.data.data || []);
      })
      .catch(() => {
        if (mounted) setProducts([]);
      })
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []);

  if (!loading && products.length === 0) return null;

  return (
    <section className="store-section reveal">
      <div className="store-section__header">
        <span className="store-section__eyebrow">{eyebrow}</span>
        <h2 className="store-section__title">{title}</h2>
      </div>

      {loading ? (
        <div className="store-section__empty">Memuat produk...</div>
      ) : (
        <div className="store-section__grid">
          {products.map((p, i) => (
            <a
              href={`/store/${p.slug}`}
              className="product-card"
              key={p.id}
              style={{ transitionDelay: `${i * 70}ms` }}
            >
              <div className="product-card__photo">
                {p.photo_url ? (
                  <img src={p.photo_url} alt={p.name} loading="lazy" />
                ) : (
                  <div className="product-card__photo-fallback" />
                )}
                {p.stock <= 0 && (
                  <span className="product-card__badge">Habis</span>
                )}
              </div>
              <div className="product-card__body">
                {p.artist_name && (
                  <p className="product-card__artist">{p.artist_name}</p>
                )}
                <h3 className="product-card__name">{p.name}</h3>
                <p className="product-card__price">{formatPrice(p.price)}</p>
              </div>
            </a>
          ))}
        </div>
      )}

      <a href="/store" className="store-section__cta">
        Lihat Semua Produk →
      </a>
    </section>
  );
}
